import {gql} from "@apollo/client";

export const sendFeedback = gql`
mutation($subject: String!, $message: String!){
  sendSupportTicketViaMail(subject: $subject, message: $message)
}
`